import CommunicationTrigger from './CommunicationTrigger';
import Icon from '../../../components/envago/Icon/Icon';
import React from 'react';

interface CommunicationHeaderSectionProps {}

const CommunicationHeaderSection = ({}: CommunicationHeaderSectionProps) => {
    return (
        <CommunicationTrigger
            triggerButtonProps={{
                children: undefined,
                iconButton: true,
                icon: (
                    <div className="text-menu-item-text bg-menu-item-bg hover:bg-menu-item-bg-hover hover:text-menu-item-text-hover  flex text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white">
                        <Icon aria={{'aria-hidden': true}} className="h-6 w-6 m-1 rounded-full" aria-hidden="true" path={Icon.Path.mdiAt} />
                        <span className={'sr-only'}>Für digitale Kommunikation anmelden</span>
                    </div>
                ),
            }}
            placement={'MENU'}
        />
    );
};

export default CommunicationHeaderSection;
